export function setToken(token) {
    localStorage.setItem("token", token);
}

export function getToken() {
    return localStorage.getItem("token") || "";
}

export function removeToken() {
    localStorage.removeItem("token");
}

export function setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
}

export function getUser() {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
}

export function removeUser() {
    localStorage.removeItem("user");
}